import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { RingLoader } from 'react-spinners';


const Loading = ({ message, isOpen,style }) => {

    let permenantMessage = 'Please be patient. This may take a while.';
    return (
        isOpen ? <div className={!style ? "loading" : `${style}`}>
            <RingLoader
                sizeUnit={'px'}
                size={120}
                color={'rgb(54, 215, 183)'}
                loading={true}
            />
            <span className="text">
                {message ? message : permenantMessage}
            </span>
        </div>
            :
            ''
    );
};


Loading.propTypes = {
    message: PropTypes.string,
    isOpen: PropTypes.bool,
};



function mapStateToProps(state) {
    let { message, isOpen, style } = state.loading;

    if (isOpen === undefined) {
        isOpen = false;
    }

    return {
        message,
        isOpen,
        style
    };
}


const temp = connect(mapStateToProps)(Loading);

export { temp as Loading };